//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import goods_nav from './goods_nav.vue';
import birthday_nav from './birthday_nav.vue';
export default {
  name: 'super_nav',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    goods_nav: goods_nav,
    birthday_nav: birthday_nav
  },
  data: function data() {
    return {
      activeTab: '0'
    };
  },
  methods: {
    tabChange: function tabChange(_, e) {
      e.preventDefault();
      e.stopPropagation();
    }
  },
  computed: {
    currentData: function currentData() {
      var data = this.value.config.value[this.activeTab];
      if (data === undefined) {
        this.activeTab = '0';
        data = this.value.config.value[0] || {};
      }
      return data;
    },
    defaultValue: function defaultValue() {
      var _this$value$config$va;
      var uid = (_this$value$config$va = this.value.config.value[this.activeTab]) === null || _this$value$config$va === void 0 ? void 0 : _this$value$config$va.uid;
      return this.value.default_value[uid] || [];
    }
  }
};